import { useCallback, useEffect, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { type POD } from '../../domain/Document'
import { getShipmentProofsOfPickup } from '../../use-cases/getShipmentProofsOfPickup'

export function useGetProofOfPickup(shipmentUUID: string) {
  const [proofsOfPickup, setProofsOfPickup] = useState<POD[]>([])
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const fetchProofOfPickup = useCallback(
    async (uuid: string, abortController?: AbortController) => {
      setRequestStatus(RequestStatus.Pending)

      try {
        const result = await getShipmentProofsOfPickup(uuid, {
          signal: abortController?.signal,
        })
        setProofsOfPickup(result)
        setRequestStatus(RequestStatus.Done)
      } catch (error) {
        if (!abortController?.signal.aborted) {
          sentry.log(error)
          setRequestStatus(RequestStatus.Error)
        }
      }
    },
    []
  )

  useEffect(() => {
    const abortController = new AbortController()

    fetchProofOfPickup(shipmentUUID, abortController)

    return () => {
      abortController.abort()
    }
  }, [fetchProofOfPickup, shipmentUUID])

  return { proofsOfPickup, fetchProofOfPickup, requestStatus }
}
